import { FC, Fragment, useEffect, useRef } from "react";
import useAppSelector from "hooks/useAppSelector";
import { Link, Navigate, Outlet } from "react-router-dom";
import { store } from "store";
import { authLogout } from "store/auth";
import { apiAuthCheck, apiFormOptions } from "apis";
import AppLoading from "components/AppLoading";
import AdminMenu from "./Menu";

const CONST_MIN_WIDTH = "76px";
const CONST_MAX_WIDTH = "80";

interface AdminContainerProps {
}

const AdminContainer: FC<AdminContainerProps> = ({
}) => {

  useEffect(() => {
    apiAuthCheck();
    apiFormOptions({});
  }, [])

  const auth = useAppSelector((state) => state.auth);
  const mainRef = useRef<HTMLElement>(null);
  const asideRef = useRef<HTMLElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const iconRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const toggle = localStorage.getItem("toggle-menu") === "1";

    if (toggle) {
      containerRef.current?.classList.add("sidebar-open");
      iconRef.current?.classList.add("fa-angle-double-left");
      iconRef.current?.classList.remove("fa-angle-double-right");
    }
    else {
      containerRef.current?.classList.remove("sidebar-open");
      iconRef.current?.classList.add("fa-angle-double-right");
      iconRef.current?.classList.remove("fa-angle-double-left");
    }
  }, [containerRef, iconRef, auth.checked, auth.invalid])

  if (!auth.checked) {
    return <AppLoading />
  }
  if (auth.invalid) {
    return <Navigate to="/administrator/login.html" replace />;
  }
  return (
    <Fragment>
      {/* transition-all duration-300  */}
      <div className={`bg-gray-100 flex min-h-screen group`} ref={containerRef}>
        <aside
          ref={asideRef}
          className={`
            lg:w-[${CONST_MIN_WIDTH}] w-0 bg-white shadow-lg h-screen fixed top-0 left-0 flex flex-col transform z-10 transition-all duration-300

            group-[.sidebar-open]:lg:w-${CONST_MAX_WIDTH}
            group-[.sidebar-open]:w-[${CONST_MIN_WIDTH}]
          `}
        >
          <Link
            className={`
              h-[61px] flex items-center space-x-3 border-b border-gray-200 lg:p-2 whitespace-nowrap overflow-hidden p-0 
              group-[.sidebar-open]:lg:p-2
            `}
            to="/administrator/profile.html"
          >
            {/* Avatar */}
            <img
              src={auth.user?.avatarUrl}
              alt={auth.user?.lastName}
              className={`
                w-10 h-10 rounded-full border border-gray-300 object-cover overfllow-hidden lg:m-0 lg:m-auto

                group-[.sidebar-open]:m-auto
              `}
            />

            {/* Thông tin */}
            <div className={`
              transform transition-all duration-300 flex-col whitespace-nowrap flex w-0 h-0 overflow-hidden opacity-0
              lg:w-0 lg:h-0 lg:opacity-0

              group-[.sidebar-open]:lg:opacity-100 
              group-[.sidebar-open]:lg:w-full 
              group-[.sidebar-open]:lg:h-full
            `}>
              <span className="font-semibold text-gray-800">{auth.user?.firstName} {auth.user?.lastName}</span>
              <span className="text-sm text-gray-500">{auth.user?.role?.name}</span>
            </div>
          </Link>
          <AdminMenu />
          <div className={`p-0 lg:p-4 border-t border-gray-200 overflow-hidden group-[.sidebar-open]:p-4`}>
            <button className="w-full bg-red-100 text-red-700 py-2 rounded hover:bg-red-200" onClick={() => store.dispatch(authLogout())}>
              Đăng xuất
            </button>
          </div>
          <button
            className="flex absolute -right-3 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow w-7 h-7 items-center hover:bg-gray-100"
            onClick={() => {
              asideRef.current?.classList.add("transition-all", "duration-300")
              mainRef.current?.classList.add("transition-all", "duration-300")
              const toggle = localStorage.getItem("toggle-menu") === "0";
              localStorage.setItem("toggle-menu", toggle ? "1" : "0")
              if (toggle) {
                containerRef.current?.classList.add("sidebar-open");
                iconRef.current?.classList.add("fa-angle-double-left");
                iconRef.current?.classList.remove("fa-angle-double-right");
              }
              else {
                containerRef.current?.classList.remove("sidebar-open");
                iconRef.current?.classList.add("fa-angle-double-right");
                iconRef.current?.classList.remove("fa-angle-double-left");
              }
              setTimeout(() => asideRef.current?.classList.remove("transition-all", "duration-300"), 300)
            }}
          >
            <i className={`fa text-xs m-auto opacity-60`} ref={iconRef}></i>
          </button>
        </aside>
        <main className={`
            w-full p-8 lg:ml-[${CONST_MIN_WIDTH}] ml-0
            group-[.sidebar-open]:ml-[${CONST_MIN_WIDTH}] 
            group-[.sidebar-open]:lg:ml-${CONST_MAX_WIDTH} 
          `}
          ref={mainRef}
        >
          <Outlet />
        </main>
        {/* <Notification /> */}
      </div>
    </Fragment>
  );
};
export default AdminContainer;
